/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Deafen_MembersInputs */



/**
* | output |
* | --- |
* | "Deafen Members" |
*
* @param {Leveling_Perm_Deafen_MembersInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_deafen_members = /** @type {((inputs?: Leveling_Perm_Deafen_MembersInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Deafen_MembersInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отключать звук участникам")
	return /** @type {LocalizedString} */ ("Deafen Members")
});